import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import { ref, onMounted } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import langMap, { defaultLang } from "@/constant/lang";
import { switchLocale } from "@/i18n";
export default /*#__PURE__*/_defineComponent({
  __name: 'lang',
  props: ["mode"],
  setup: function setup(__props) {
    var props = __props;
    var router = useRouter();
    var value = ref("en");
    onMounted(function () {
      var currentRoute = router.resolve(window.location.pathname);
      var langKey = currentRoute.params.lang || defaultLang;
      value.value = langKey;
    });
    var onLangChange = function onLangChange(lang) {
      if (lang === value.value) return;
      value.value = lang;
      if (lang === defaultLang) {
        lang = "";
      }
      var currentRoute = router.resolve(window.location.pathname);
      router.replace({
        name: currentRoute.name,
        params: _objectSpread(_objectSpread({}, router.currentRoute.value.params), {}, {
          lang: lang
        }),
        query: _objectSpread({}, router.currentRoute.value.query)
      }).then(function (res) {
        location.reload();
      });
      switchLocale(lang || defaultLang);
    };
    return function (_ctx, _cache) {
      var _component_a_menu_item = _resolveComponent("a-menu-item");
      var _component_a_menu = _resolveComponent("a-menu");
      var _component_a_dropdown = _resolveComponent("a-dropdown");
      return _openBlock(), _createBlock(_component_a_dropdown, {
        placement: "bottom",
        "class": _normalizeClass({
          white: props.mode === 'white'
        })
      }, {
        overlay: _withCtx(function () {
          return [_createVNode(_component_a_menu, {
            "class": "menu"
          }, {
            "default": _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langMap), function (lang, key) {
                return _openBlock(), _createBlock(_component_a_menu_item, {
                  onClick: function onClick($event) {
                    return onLangChange(key);
                  }
                }, {
                  "default": _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(lang.label), 1)];
                  }),
                  _: 2
                }, 1032, ["onClick"]);
              }), 256))];
            }),
            _: 1
          })];
        }),
        "default": _withCtx(function () {
          return [_createElementVNode("a", {
            "class": "ant-dropdown-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["prevent"]))
          }, [_createTextVNode(_toDisplayString(_unref(langMap)[value.value].label) + " ", 1), _createVNode(_unref(DownOutlined))])];
        }),
        _: 1
      }, 8, ["class"]);
    };
  }
});